



import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "uc-header-icon-panel"
})
export default class UcHeaderIconPanelComponent extends Vue {
  @Prop({default:"icon-twoarrow",type:String})
  icon:String;
  
  onClick(){
    this.$emit("onClick")
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/header/uc-header-ico-panel.vue